import SquareColorComponent from "../../components/inputs/SquareColorComponent";

const LegendDescriptionComponent = ({ legendItems }) => {

    let legend = legendItems.map((x, index) =>
        <div id={`legend-item-${index}`} style={{
            display: 'flex',
            justifyContent: 'start',
            alignItems: 'flex-end',
            gap: '20px',
            marginTop: index === 0 ? '0%' : '2%',
        }}>
            <SquareColorComponent value={x.hex}// '#d4fae0'
            />
            <span className='p-disabled'> {x.name}</span>
        </div>
    )

    return legend;
}


export default LegendDescriptionComponent; 